import { type ReactNode } from "react";

import { SessionProvider } from "@/core/auth/useSession";

/**
 * Auth provider du cockpit Dozka — server-side session pattern.
 *
 * Avant : `<AuthKitProvider>` de @workos-inc/authkit-react geignait l'OAuth
 * dans le browser. Bug structurel : access_token en RAM, refresh via cookie
 * sur api.workos.com (third-party) → bloque par les browsers modernes →
 * session perdue au reload / apres ~10 min.
 *
 * Maintenant : `<SessionProvider>` charge l'identite via /api/auth/me
 * (cookie httpOnly first-party sur dozka.app via le proxy nginx /api/* →
 * francis.simpme.fr). Le browser ne touche jamais le JWT WorkOS.
 *
 * Le sign-in est un redirect vers /api/auth/login (qui re-redirect vers
 * WorkOS). Le sign-out est un POST /api/auth/logout puis un reload.
 */
export function AuthProvider({ children }: { children: ReactNode }) {
  return <SessionProvider>{children}</SessionProvider>;
}
